import { FC, useCallback } from 'react'

import { dashboard20240730Client } from '@sequencehq/api/dashboard/v20240730'
import { useNotifications, SimpleModal } from '@sequencehq/core-components'

export const ArchiveProductModal: FC<{
  productId: string
  productName: string
  onClose: () => void
  onSuccess: () => void
}> = ({ productId, productName, onClose, onSuccess }) => {
  const { displayNotification } = useNotifications()

  const archiveProduct = useCallback(async () => {
    const archiveRes = await dashboard20240730Client.postProductArchive({
      id: productId
    })

    if (archiveRes.error) {
      const errorResponse = await archiveRes.res.json()

      displayNotification(`Unable to archive ${productName}`, {
        type: 'error',
        description:
          errorResponse?.error?.errors?.[0]?.message ??
          'Something went wrong, please try again.'
      })

      return false
    }

    displayNotification('Product archived', { type: 'success' })

    onSuccess()

    return true
  }, [displayNotification, productId, productName, onSuccess])

  return (
    <SimpleModal
      isOpen
      onClose={onClose}
      variant="dialog"
      title={`Archive ${productName}`}
      submitButtonText="Archive"
      submittingButtonText="Archiving..."
      isDestructive
      onSubmit={async () => {
        const result = await archiveProduct()
        return result
      }}
    >
      This will archive the product immediately.
    </SimpleModal>
  )
}
